import {Howl} from 'howler'
import {useState} from 'react'

const alarme = require('../../assets/sons/alarme.mp3')

export const AudioFunction = () => {
  //   const {PermitUseGet, alarm, setVolumeAudio, volumeAudio} = useLocalStorage()

  const [volume] = useState(1)

  const sound = new Howl({
    src: [alarme],
    volume: 1, // volume do áudio (0 a 1)
    loop: false, // se o áudio deve repetir
    autoplay: false, // se o áudio deve iniciar automaticamente
    preload: true, // se o áudio deve ser pré-carregado

    onend: () => {
      console.log('tocando')
    },
    onloaderror: (error: any) => {
      console.error('Erro ao carregar áudio:', error)
    },
  })

  const handlePlay = () => {
    sound.play()
  }
  const handlePause = () => {
    sound.pause()
  }

  const handleStop = () => {
    sound.stop()
  }

  return {handlePlay, handlePause, handleStop, volume}
}
